import { useLoanCentricSidebarNavEnabled } from "hooks/useLoanCentricSidebarNavEnabled";
import MyLoans from "pages/my-loans/MyLoans";
import MyLoansShellLayout from "../my-loans-shell-layout/MyLoansShellLayout";

const MyLoansRoute = () => {
  const loanCentricSidebarNavEnabled = useLoanCentricSidebarNavEnabled();

  return loanCentricSidebarNavEnabled ? <MyLoansShellLayout /> : <MyLoans />;
};

export default MyLoansRoute;
